import { statsOnWidgetInteraction } from '../stats';

export function galleryHover() {
  if (document.querySelectorAll('.gallery_hover').length) {
    // timery na klasę 'tapped' per kafelek – trzymane, żeby móc je anulować przy
    // zamknięciu; bez tego timer domykał się na już zamkniętym kafelku
    const pinTimers = new WeakMap();
    // kafelki, dla których stat już poszedł – jedno zgłoszenie na kafelek,
    // bo na mobile ten sam kafelek otwiera się wielokrotnie (tap w plus,
    // emulowany mouseleave przy kolejnym tapie) i inaczej dubluje eventy
    const statSent = new WeakSet();

    const itemHover = function (item) {
      const pin = item.querySelector('.gallery_hover__pin');
      item.classList.add('item--active');
      clearTimeout(pinTimers.get(item));
      pinTimers.set(item, setTimeout(() => {
        pin.classList.add('tapped');
      }, 500));
      // stat wysyłamy z momentu otwarcia opisu, a nie z listenera na kafelku –
      // na mobile opis otwiera plus, a jego handler zatrzymuje propagację,
      // więc stat z kafelka nigdy nie leciał
      if (!statSent.has(item)) {
        statSent.add(item);
        statsOnWidgetInteraction(
          item,
          item.querySelector('.gallery_hover__img').getAttribute('src'),
        );
      }
    };

    const itemClose = function (item) {
      clearTimeout(pinTimers.get(item));
      item.classList.remove('item--active');
      item.querySelector('.gallery_hover__pin').classList.remove('tapped');
      // zamknięcie kończy interakcję – kolejne otwarcie tego samego kafelka
      // ma się liczyć jako nowa interakcja i znowu wysłać stat
      statSent.delete(item);
    };

    const eventName = 'ontouchstart' in document.documentElement ? 'click' : 'mouseenter';

    document.querySelectorAll('.gallery_hover').forEach((gallery) => {
      gallery.querySelectorAll('.widget__item').forEach((el) => {
        el.addEventListener(eventName, function () {
          itemHover(this);
        });
      });

      gallery.querySelectorAll('.widget__item').forEach((el) => {
        el.addEventListener('mouseleave', function () {
          itemClose(this);
        });
      });

      gallery.querySelectorAll('.gallery_hover__pin').forEach((el) => {
        el.addEventListener('click', (ev) => {
          ev.stopPropagation();
          const item = el.closest('.widget__item');
          // stan bierzemy z kafelka, nie z klasy 'tapped' (ta pojawia się z
          // opóźnieniem 500 ms, więc szybki klik nie zamykał opisu)
          if (item.classList.contains('item--active')) {
            itemClose(item);
          } else {
            itemHover(item);
          }
        });
      });
    });
  }
}
